const clientSorting = (items, sortBy, sortAsc) => {
  let direction = sortAsc ? -1 : 1;

  return items.sort((a, b) => {
    if (a[sortBy] > b[sortBy]) {
      return direction;
    }
    if (a[sortBy] < b[sortBy]) {
      return direction * -1;
    }
    return 0;
  });
};

export default clientSorting;
